export default __webpack_public_path__ + "static/media/shahzadi._compressed.1b2c89d1.pdf";